var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 402,
    viewBox: "0 0 486 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Results"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M19.1191 184.875V188.972",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M9.91406 187.102L13.2615 190.547",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M6 196.266H10.7332",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M9.5332 205.618L12.8806 202.172",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M19.1191 206.737V202.641",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 10",
    d: "M25.9459 203.989L23.2148 201.258",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M31.4071 197.18H27.3105",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    d: "M28.6763 187.617L25.9453 190.348",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M238.963 6V8.73101",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M230.771 14.2031H233.502",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M238.963 22.3951V19.6641",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M245.79 14.2031H243.059",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M80.5664 120.703V124.8",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M68.2734 132.984H72.3699",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M80.5664 143.925V139.828",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M91.4891 132.984H87.3926",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    d: "M374.488 269.578C377.751 269.578 380.398 272.225 380.398 275.49C380.398 278.755 377.751 281.401 374.488 281.401C371.225 281.401 368.578 278.755 368.578 275.49",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.537 215.949C405.046 214.854 410.425 210.563 411.67 205.945C412.799 210.027 417.533 214.854 421.803 215.219C416.996 216.922 412.399 221.979 411.67 225.951C411.174 221.902 404.817 216.539 401.537 215.949",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.332 267.759C43.0871 267.212 45.7755 265.066 46.398 262.758C46.9625 264.797 49.3286 267.212 51.4639 267.395C49.0608 268.245 46.7631 270.774 46.398 272.76C46.1499 270.736 42.9712 268.054 41.332 267.759",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9053 77.8025C73.9053 80.335 71.8534 82.3862 69.3228 82.3862C66.791 82.3862 64.7402 80.335 64.7402 77.8025C64.7402 75.2712 66.791 73.2188 69.3228 73.2188C71.8534 73.2188 73.9053 75.2712 73.9053 77.8025",
    fill: "#D1D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.907 90.1143C379.907 94.3456 376.477 97.7755 372.248 97.7755C368.017 97.7755 364.588 94.3456 364.588 90.1143C364.588 85.8831 368.017 82.4531 372.248 82.4531C376.477 82.4531 379.907 85.8831 379.907 90.1143",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.998 69.3585C485.998 72.7154 483.278 75.4357 479.923 75.4357C476.567 75.4357 473.848 72.7154 473.848 69.3585C473.848 66.0016 476.567 63.2812 479.923 63.2812C483.278 63.2812 485.998 66.0016 485.998 69.3585",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.546 353.191C159.546 355.307 157.831 357.022 155.716 357.022C153.601 357.022 151.887 355.307 151.887 353.191C151.887 351.074 153.601 349.359 155.716 349.359C157.831 349.359 159.546 351.074 159.546 353.191Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.267 48.365C157.267 50.8975 155.215 52.9487 152.684 52.9487C150.153 52.9487 148.102 50.8975 148.102 48.365C148.102 45.8337 150.153 43.7812 152.684 43.7812C155.215 43.7812 157.267 45.8337 157.267 48.365Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.159 395.612C271.23 396.726 267.953 395.255 266.839 392.327C265.725 389.398 267.195 386.118 270.124 385.005C273.052 383.891 276.329 385.361 277.443 388.29C278.558 391.219 277.087 394.497 274.159 395.612Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.414 287.299H160.437C152.555 287.299 146.104 280.828 146.104 272.92V113.235C146.104 105.327 152.555 98.8594 160.437 98.8594H272.414C280.299 98.8594 286.75 105.327 286.75 113.235V272.92C286.75 280.828 280.299 287.299 272.414 287.299",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.852 294.119H150.874C142.992 294.119 136.541 287.649 136.541 279.741V120.055C136.541 112.147 142.992 105.68 150.874 105.68H262.852C270.736 105.68 277.188 112.147 277.188 120.055V279.741C277.188 287.649 270.736 294.119 262.852 294.119",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.556 299.526H141.347C133.449 299.526 126.984 293.083 126.984 285.207V126.183C126.984 118.308 133.449 111.867 141.347 111.867H253.556C261.457 111.867 267.922 118.308 267.922 126.183V285.207C267.922 293.083 261.457 299.526 253.556 299.526",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.556 299.526H141.347C133.449 299.526 126.984 293.083 126.984 285.207V126.183C126.984 118.308 133.449 111.867 141.347 111.867H253.556C261.457 111.867 267.922 118.308 267.922 126.183V285.207C267.922 293.083 261.457 299.526 253.556 299.526",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.384 160.302H154.504C152.137 160.302 150.199 158.459 150.199 156.207C150.199 153.953 152.137 152.109 154.504 152.109H237.384C239.751 152.109 241.688 153.953 241.688 156.207C241.688 158.459 239.751 160.302 237.384 160.302",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.384 184.888H154.504C152.137 184.888 150.199 183.045 150.199 180.793C150.199 178.539 152.137 176.695 154.504 176.695H237.384C239.751 176.695 241.688 178.539 241.688 180.793C241.688 183.045 239.751 184.888 237.384 184.888",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.384 209.474H154.504C152.137 209.474 150.199 207.631 150.199 205.379C150.199 203.128 152.137 201.281 154.504 201.281H237.384C239.751 201.281 241.688 203.128 241.688 205.379C241.688 207.631 239.751 209.474 237.384 209.474",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.384 234.037H154.504C152.137 234.037 150.199 232.194 150.199 229.942C150.199 227.687 152.137 225.844 154.504 225.844H237.384C239.751 225.844 241.688 227.687 241.688 229.942C241.688 232.194 239.751 234.037 237.384 234.037",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.766 258.623H154.522C152.145 258.623 150.199 256.78 150.199 254.528C150.199 252.273 152.145 250.43 154.522 250.43H197.766C200.143 250.43 202.088 252.273 202.088 254.528C202.088 256.78 200.143 258.623 197.766 258.623",
    fill: "#E0E2EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.051 226.86C268.478 243.43 242.821 245.299 224.195 232.506C221.814 230.842 219.549 228.972 217.436 226.86C216.348 225.776 215.323 224.657 214.357 223.479C212.425 221.127 210.732 218.618 209.346 216.026C206.903 211.648 205.242 207.003 204.335 202.201C201.409 187.143 205.784 170.934 217.436 159.288C229.116 147.607 245.327 143.26 260.388 146.158C265.187 147.092 269.837 148.753 274.215 151.168C276.811 152.585 279.286 154.278 281.642 156.209C282.816 157.172 283.935 158.2 285.019 159.288C287.136 161.4 289.033 163.662 290.666 166.046C303.465 184.666 301.592 210.321 285.051 226.86",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.415 223.592C263.173 240.837 235.232 240.834 217.987 223.592C200.764 206.37 200.764 178.425 218.009 161.184C235.232 143.961 263.173 143.961 280.396 161.184C297.637 178.425 297.637 206.37 280.415 223.592ZM289.264 152.325C267.133 130.194 231.27 130.194 209.139 152.325C187.011 174.453 186.992 210.338 209.12 232.47C229.262 252.605 260.832 254.421 283.037 237.888C285.205 236.271 287.294 234.459 289.286 232.47C291.276 230.477 293.088 228.388 294.702 226.22C311.235 204.011 309.403 172.464 289.264 152.325Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.357 315.885L375.428 316.814C369.281 322.964 359.216 322.964 353.065 316.814L296.309 260.057L319.6 236.766L376.357 293.522C382.507 299.673 382.507 309.735 376.357 315.885",
    fill: "url(#paint0_linear_5081_48622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.925 224.484L312.697 241.256L300.79 253.16L284.021 236.388C286.235 234.738 288.363 232.888 290.399 230.859C292.429 228.829 294.278 226.697 295.925 224.484",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.509 292.826L352.366 315.966L348.199 311.797L371.34 288.656L375.509 292.826Z",
    fill: "#EF545F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.888 237.579L297.111 261.357L293.578 257.825L317.355 234.047L320.888 237.579Z",
    fill: "url(#paint1_linear_5081_48622)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.999 155.254L210.687 213.563C208.491 209.627 206.998 205.451 206.186 201.134L256.569 150.75C260.883 151.593 265.063 153.083 268.999 155.254",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.12 169.118L225.078 228.588C222.821 227.101 220.672 225.429 218.668 223.538C217.637 222.565 216.661 221.567 215.748 220.513L279.557 160.312C280.675 161.177 281.736 162.097 282.764 163.07C284.768 164.961 286.571 166.985 288.12 169.118",
    fill: "white",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5081_48622",
    x1: 338.639,
    y1: 194.435,
    x2: 253.978,
    y2: 279.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5081_48622",
    x1: 307.233,
    y1: 220.392,
    x2: 279.923,
    y2: 247.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/NoResults.51dc7e23ba169c04f529cdbc8864b3bd.svg";
export { ForwardRef as ReactComponent };